import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=6944f5c6&scoped=true&"
import script from "./InputItem.vue?vue&type=script&lang=js&"
export * from "./InputItem.vue?vue&type=script&lang=js&"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=6944f5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944f5c6",
  null
  
)

export default component.exports